import React from "react";
import { NavLink } from "react-router-dom";
import s from './Header.module.css';

function Header(props) {
    return (
        <header className={s.header}>
            <img src="https://cdn.logo.com/hotlink-ok/logo-social.png" />
            <div className={s.loginBlock}>
                { props.isAuth 
                ? <div>{props.login} <br/> <button onClick={props.logoutThunk}>Log out</button></div>
                : <NavLink to={'/login'}>Login</NavLink> }
            </div>
        </header>
    );
}

export default Header;